<template>
    <!-- <el-dialog
      title="视频预览"
      :visible.sync="dialogVisible"

    >
		<video-player
			v-if="option.url"
      style="width: 100%;height: 100%;"
      :playsinline="true"
      :options="option"
    ></video-player>
    </el-dialog> -->

		<el-dialog
		  title="视频预览"
		  :visible.sync="dialogVisible"
			show-close
			top="3vh"
			width="60vw"
			:before-close="handleClose">
			<div class="video-player-box" v-if="option.sources!=''">
				<video-player
    	  style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;"
    	  :playsinline="true"
    	  :options="option"
    	></video-player>
			</div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="close()">取 消</el-button>
		    <el-button type="primary" @click="close()">确 定</el-button>
		  </span>
		</el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      option:{
				playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: "",
        // poster: "https://p1.music.126.net/5zs7IvmLv7KahY3BFzUmrg==/109951163635241613.jpg?param=600y500", // 你的封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true  // 全屏按钮
        }

			}
    };
  },
  watch: {
    
  },
  methods: {
    open(url) {
      this.dialogVisible = true;
			this.option.sources = url;
    },
    close() {
      this.dialogVisible = false;
      this.option.sources = "";
    },
		handleClose(){
			this.close();
		}
  }
};
</script>

<style scoped>

.video-player-box{
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.video-player-box >>> .video-js{
	width: 100%;
	height: 100%;
}

.video-player-box >>> .vjs-big-play-button{
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/previewVideoDialog.vue